export const ReservationsEmptyStateIcon = () => {
  return (
    <svg
      width="299"
      height="211"
      viewBox="0 0 299 211"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="45.9082"
        y="189.244"
        width="43.2047"
        height="43.2047"
        rx="21.6024"
        transform="rotate(-90 45.9082 189.244)"
        fill="url(#paint0_linear_1871_5985)"
      />
      <rect
        x="45.9082"
        y="189.244"
        width="43.2047"
        height="43.2047"
        rx="21.6024"
        transform="rotate(-90 45.9082 189.244)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="42.6028" y="140.831" width="49.779" height="52.227">
        <div
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_0_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter0_i_1871_5985)"
        data-figma-bg-blur-radius="10.6086"
      >
        <rect
          x="81.7732"
          y="182.449"
          width="28.5617"
          height="31.0098"
          rx="14.0296"
          transform="rotate(-180 81.7732 182.449)"
          fill="url(#paint1_linear_1871_5985)"
        />
        <rect
          x="81.4468"
          y="182.123"
          width="27.9089"
          height="30.357"
          rx="13.7031"
          transform="rotate(-180 81.4468 182.123)"
          stroke="url(#paint2_linear_1871_5985)"
          strokeWidth="0.652839"
        />
      </g>
      <rect
        x="45.9082"
        y="127.469"
        width="43.2047"
        height="43.2047"
        rx="21.6024"
        transform="rotate(-90 45.9082 127.469)"
        fill="url(#paint3_linear_1871_5985)"
      />
      <rect
        x="45.9082"
        y="127.469"
        width="43.2047"
        height="43.2047"
        rx="21.6024"
        transform="rotate(-90 45.9082 127.469)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="42.6028" y="79.0554" width="49.779" height="52.227">
        <div
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_1_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter1_i_1871_5985)"
        data-figma-bg-blur-radius="10.6086"
      >
        <rect
          x="81.7732"
          y="120.674"
          width="28.5617"
          height="31.0098"
          rx="14.0296"
          transform="rotate(-180 81.7732 120.674)"
          fill="url(#paint4_linear_1871_5985)"
        />
        <rect
          x="81.4468"
          y="120.347"
          width="27.9089"
          height="30.357"
          rx="13.7031"
          transform="rotate(-180 81.4468 120.347)"
          stroke="url(#paint5_linear_1871_5985)"
          strokeWidth="0.652839"
        />
      </g>
      <rect
        x="45.9082"
        y="65.6953"
        width="43.2047"
        height="43.2047"
        rx="21.6024"
        transform="rotate(-90 45.9082 65.6953)"
        fill="url(#paint6_linear_1871_5985)"
      />
      <rect
        x="45.9082"
        y="65.6953"
        width="43.2047"
        height="43.2047"
        rx="21.6024"
        transform="rotate(-90 45.9082 65.6953)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="42.6028" y="17.282" width="49.779" height="52.227">
        <div
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_2_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter2_i_1871_5985)"
        data-figma-bg-blur-radius="10.6086"
      >
        <rect
          x="81.7732"
          y="58.9004"
          width="28.5617"
          height="31.0098"
          rx="14.0296"
          transform="rotate(-180 81.7732 58.9004)"
          fill="url(#paint7_linear_1871_5985)"
        />
        <rect
          x="81.4468"
          y="58.574"
          width="27.9089"
          height="30.357"
          rx="13.7031"
          transform="rotate(-180 81.4468 58.574)"
          stroke="url(#paint8_linear_1871_5985)"
          strokeWidth="0.652839"
        />
      </g>
      <rect
        x="105.113"
        y="195.867"
        width="180"
        height="98"
        rx="22"
        transform="rotate(-90 105.113 195.867)"
        fill="url(#paint9_linear_1871_5985)"
      />
      <rect
        x="105.113"
        y="195.867"
        width="180"
        height="98"
        rx="22"
        transform="rotate(-90 105.113 195.867)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="101.613" y="15.3672" width="107" height="184">
        <div
          style={{
            backdropFilter: "blur(6.5px)",
            clipPath: "url(#bgblur_3_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g filter="url(#filter3_i_1871_5985)" data-figma-bg-blur-radius="13">
        <rect
          x="195.613"
          y="186.367"
          width="81"
          height="158"
          rx="12"
          transform="rotate(-180 195.613 186.367)"
          fill="url(#paint10_linear_1871_5985)"
        />
        <rect
          x="195.213"
          y="185.967"
          width="80.2"
          height="157.2"
          rx="11.6"
          transform="rotate(-180 195.213 185.967)"
          stroke="url(#paint11_linear_1871_5985)"
          strokeWidth="0.8"
        />
      </g>
      <rect
        x="219.113"
        y="189.244"
        width="43.2047"
        height="43.2047"
        rx="11.27"
        transform="rotate(-90 219.113 189.244)"
        fill="url(#paint12_linear_1871_5985)"
      />
      <rect
        x="219.113"
        y="189.244"
        width="43.2047"
        height="43.2047"
        rx="11.27"
        transform="rotate(-90 219.113 189.244)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="215.808" y="140.831" width="49.779" height="52.227">
        <div
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_4_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter4_i_1871_5985)"
        data-figma-bg-blur-radius="10.6086"
      >
        <rect
          x="254.978"
          y="182.449"
          width="28.5617"
          height="31.0098"
          rx="6.03"
          transform="rotate(-180 254.978 182.449)"
          fill="url(#paint13_linear_1871_5985)"
        />
        <rect
          x="254.652"
          y="182.123"
          width="27.9089"
          height="30.357"
          rx="5.70358"
          transform="rotate(-180 254.652 182.123)"
          stroke="url(#paint14_linear_1871_5985)"
          strokeWidth="0.652839"
        />
      </g>
      <rect
        x="219.113"
        y="127.469"
        width="43.2047"
        height="43.2047"
        rx="11.27"
        transform="rotate(-90 219.113 127.469)"
        fill="url(#paint15_linear_1871_5985)"
      />
      <rect
        x="219.113"
        y="127.469"
        width="43.2047"
        height="43.2047"
        rx="11.27"
        transform="rotate(-90 219.113 127.469)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="215.808" y="79.0554" width="49.779" height="52.227">
        <div
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_5_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter5_i_1871_5985)"
        data-figma-bg-blur-radius="10.6086"
      >
        <rect
          x="254.978"
          y="120.674"
          width="28.5617"
          height="31.0098"
          rx="6.03"
          transform="rotate(-180 254.978 120.674)"
          fill="url(#paint16_linear_1871_5985)"
        />
        <rect
          x="254.652"
          y="120.347"
          width="27.9089"
          height="30.357"
          rx="5.70358"
          transform="rotate(-180 254.652 120.347)"
          stroke="url(#paint17_linear_1871_5985)"
          strokeWidth="0.652839"
        />
      </g>
      <rect
        x="219.113"
        y="65.6953"
        width="43.2047"
        height="43.2047"
        rx="11.27"
        transform="rotate(-90 219.113 65.6953)"
        fill="url(#paint18_linear_1871_5985)"
      />
      <rect
        x="219.113"
        y="65.6953"
        width="43.2047"
        height="43.2047"
        rx="11.27"
        transform="rotate(-90 219.113 65.6953)"
        fill="black"
        fillOpacity={0.1}
      />
      <foreignObject x="215.808" y="17.282" width="49.779" height="52.227">
        <div
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_6_1871_5985_clip_path)",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </foreignObject>
      <g
        opacity="0.4"
        filter="url(#filter6_i_1871_5985)"
        data-figma-bg-blur-radius="10.6086"
      >
        <rect
          x="254.978"
          y="58.9004"
          width="28.5617"
          height="31.0098"
          rx="6.03"
          transform="rotate(-180 254.978 58.9004)"
          fill="url(#paint19_linear_1871_5985)"
        />
        <rect
          x="254.652"
          y="58.574"
          width="27.9089"
          height="30.357"
          rx="5.70358"
          transform="rotate(-180 254.652 58.574)"
          stroke="url(#paint20_linear_1871_5985)"
          strokeWidth="0.652839"
        />
      </g>
      <rect
        x="245.408"
        y="9.36719"
        width="53"
        height="190"
        fill="url(#paint21_linear_1871_5985)"
      />
      <rect
        width="79"
        height="202"
        transform="matrix(-1 0 0 1 79.4082 6.36719)"
        fill="url(#paint22_linear_1871_5985)"
      />
      <defs>
        <filter
          id="filter0_i_1871_5985"
          x="42.6028"
          y="140.831"
          width="49.779"
          height="52.227"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8.16048"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-4.89629" dy="4.89629" />
          <feGaussianBlur stdDeviation="3.26419" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_0_1871_5985_clip_path"
          transform="translate(-42.6028 -140.831)"
        >
          <rect
            x="81.7732"
            y="182.449"
            width="28.5617"
            height="31.0098"
            rx="14.0296"
            transform="rotate(-180 81.7732 182.449)"
          />
        </clipPath>
        <filter
          id="filter1_i_1871_5985"
          x="42.6028"
          y="79.0554"
          width="49.779"
          height="52.227"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8.16048"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-4.89629" dy="4.89629" />
          <feGaussianBlur stdDeviation="3.26419" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_1_1871_5985_clip_path"
          transform="translate(-42.6028 -79.0554)"
        >
          <rect
            x="81.7732"
            y="120.674"
            width="28.5617"
            height="31.0098"
            rx="14.0296"
            transform="rotate(-180 81.7732 120.674)"
          />
        </clipPath>
        <filter
          id="filter2_i_1871_5985"
          x="42.6028"
          y="17.282"
          width="49.779"
          height="52.227"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8.16048"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-4.89629" dy="4.89629" />
          <feGaussianBlur stdDeviation="3.26419" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_2_1871_5985_clip_path"
          transform="translate(-42.6028 -17.282)"
        >
          <rect
            x="81.7732"
            y="58.9004"
            width="28.5617"
            height="31.0098"
            rx="14.0296"
            transform="rotate(-180 81.7732 58.9004)"
          />
        </clipPath>
        <filter
          id="filter3_i_1871_5985"
          x="101.613"
          y="15.3672"
          width="107"
          height="184"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="10"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-6" dy="6" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_3_1871_5985_clip_path"
          transform="translate(-101.613 -15.3672)"
        >
          <rect
            x="195.613"
            y="186.367"
            width="81"
            height="158"
            rx="12"
            transform="rotate(-180 195.613 186.367)"
          />
        </clipPath>
        <filter
          id="filter4_i_1871_5985"
          x="215.808"
          y="140.831"
          width="49.779"
          height="52.227"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8.16048"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-4.89629" dy="4.89629" />
          <feGaussianBlur stdDeviation="3.26419" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_4_1871_5985_clip_path"
          transform="translate(-215.808 -140.831)"
        >
          <rect
            x="254.978"
            y="182.449"
            width="28.5617"
            height="31.0098"
            rx="6.03"
            transform="rotate(-180 254.978 182.449)"
          />
        </clipPath>
        <filter
          id="filter5_i_1871_5985"
          x="215.808"
          y="79.0554"
          width="49.779"
          height="52.227"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8.16048"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-4.89629" dy="4.89629" />
          <feGaussianBlur stdDeviation="3.26419" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_5_1871_5985_clip_path"
          transform="translate(-215.808 -79.0554)"
        >
          <rect
            x="254.978"
            y="120.674"
            width="28.5617"
            height="31.0098"
            rx="6.03"
            transform="rotate(-180 254.978 120.674)"
          />
        </clipPath>
        <filter
          id="filter6_i_1871_5985"
          x="215.808"
          y="17.282"
          width="49.779"
          height="52.227"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="8.16048"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_1871_5985"
          />
          <feOffset dx="-4.89629" dy="4.89629" />
          <feGaussianBlur stdDeviation="3.26419" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1871_5985"
          />
        </filter>
        <clipPath
          id="bgblur_6_1871_5985_clip_path"
          transform="translate(-215.808 -17.282)"
        >
          <rect
            x="254.978"
            y="58.9004"
            width="28.5617"
            height="31.0098"
            rx="14.0296"
            transform="rotate(-180 81.7732 58.9004)"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_1871_5985"
          x1="54.7849"
          y1="189.244"
          x2="94.2317"
          y2="233.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1871_5985"
          x1="81.7732"
          y1="197.954"
          x2="110.335"
          y2="197.954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1871_5985"
          x1="81.7732"
          y1="184.855"
          x2="94.1247"
          y2="215.721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1871_5985"
          x1="54.7849"
          y1="127.469"
          x2="94.2317"
          y2="171.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1871_5985"
          x1="81.7732"
          y1="136.179"
          x2="110.335"
          y2="136.179"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1871_5985"
          x1="81.7732"
          y1="123.08"
          x2="94.1247"
          y2="153.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1871_5985"
          x1="54.7849"
          y1="65.6953"
          x2="94.2317"
          y2="109.889"
          gradientUnits="userSpaceUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1871_5985"
          x1="81.7732"
          y1="74.4053"
          x2="110.335"
          y2="74.4053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1871_5985"
          x1="81.7732"
          y1="61.3063"
          x2="94.1247"
          y2="92.1726"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1871_5985"
          x1="142.095"
          y1="195.867"
          x2="212.9"
          y2="341.568"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1871_5985"
          x1="195.613"
          y1="265.367"
          x2="276.613"
          y2="265.367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1871_5985"
          x1="195.613"
          y1="198.626"
          x2="282.088"
          y2="318.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1871_5985"
          x1="227.99"
          y1="189.244"
          x2="267.437"
          y2="233.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1871_5985"
          x1="254.978"
          y1="197.954"
          x2="283.54"
          y2="197.954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint14_linear_1871_5985"
          x1="254.978"
          y1="184.855"
          x2="267.329"
          y2="215.721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_1871_5985"
          x1="227.99"
          y1="127.469"
          x2="267.437"
          y2="171.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_1871_5985"
          x1="254.978"
          y1="136.179"
          x2="283.54"
          y2="136.179"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint17_linear_1871_5985"
          x1="254.978"
          y1="123.08"
          x2="267.329"
          y2="153.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_1871_5985"
          x1="227.99"
          y1="65.6953"
          x2="267.437"
          y2="109.889"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stopOpacity={0} />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_1871_5985"
          x1="254.978"
          y1="74.4053"
          x2="283.54"
          y2="74.4053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FDFC" />
          <stop offset="1" stopColor="#F7FDFC" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint20_linear_1871_5985"
          x1="254.978"
          y1="61.3063"
          x2="267.329"
          y2="92.1726"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0.5} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_1871_5985"
          x1="248.466"
          y1="113.795"
          x2="289.235"
          y2="113.795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_1871_5985"
          x1="4.55769"
          y1="111.023"
          x2="65.3269"
          y2="111.023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity={0} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
